import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignLeftOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M3 5h26a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m0 8h18.42a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2m26 6H3a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2m-14.08 8H3a1 1 0 0 0 0 2h11.92a1 1 0 1 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignLeftOutlineSVG);
ForwardRef.displayName = "IconTextAlignLeftOutline";
export { ForwardRef as IconTextAlignLeftOutline };
